import { Format } from "../../../utils/types/generals";
import { FilterArea } from "../response/index";

export const formatFilterArea = async ({ response }: { response: FilterArea }): Format<FilterArea> => {
    return await {
        item: response.map(area => ({ label: area.name, value: area.id, id: area.id.toString() })),
        data: response
    }
}